import useGetColors from "../../utils/colors";
import signInBg from "../../assets/images/signInBg.png";
import t from "../../theme";
import { doodleBackgroundImage } from "../../utils/doodlePattern";

export const useGetTemplateSyles = ({
  singleColumn,
  bgNone,
  logoMarginNone,
}) => {
  const { signInTemplateColors } = useGetColors();

  return {
    templateContainer: {
      display: "flex",
      gap: 0,
      width: "100%",
      flex: 1,
      padding: "0px",
      flexDirection: singleColumn ? "column" : "row",
      backgroundImage: `url(${signInBg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      minHeight: "100vh",
    },

    /* ─── Left: glassmorphic overlay on existing background ─── */
    templateLeftSectionWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: 40,
      flex: singleColumn ? "unset" : 1,
      overflow: "hidden",
      padding: "0",
      background:
        "linear-gradient(160deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.08) 100%)",
      backdropFilter: "saturate(180%) blur(12px)",
      WebkitBackdropFilter: "saturate(180%) blur(12px)",
      borderRight: "1px solid rgba(255,255,255,0.2)",
      position: "relative",
    },
    appLogo: {
      width: "70%",
      margin: logoMarginNone ? "0 auto" : "40px auto 0",
      maxWidth: 300,
    },
    templateIllustrationWrapper: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      alignItems: "center",
      justifyContent: "flex-end",
    },
    illustrationText: {
      margin: 0,
      fontWeight: "normal",
      color: signInTemplateColors.illustratorTextColor,
      fontFamily: "'Open Sans', sans-serif",
      textAlign: "center",
    },
    illustration: {
      height: "100%",
    },

    /* ─── Right: green theme with professional polish ─── */
    templateRightSectionWrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      flex: 1,
      background: !bgNone
        ? "linear-gradient(160deg, #4a9b2e 0%, #3d8a27 30%, #276b22 70%, #1a521c 100%)"
        : "transparent",
      color: !bgNone
        ? "#ffffff"
        : signInTemplateColors.templateRightSectionTextColor,
      boxShadow: !bgNone ? "inset 2px 0 24px rgba(0,0,0,0.15)" : "none",
      position: "relative",
      overflow: "hidden",
      /* improve text rendering on colored backgrounds */
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      textRendering: "optimizeLegibility",
      /* doodle pattern overlay */
      "&::before": !bgNone
        ? {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: doodleBackgroundImage,
            backgroundSize: "300px 300px",
            backgroundRepeat: "repeat",
            opacity: 1,
            pointerEvents: "none",
          }
        : {},
      ...(singleColumn && !bgNone
        ? {
            width: "100%",
            maxWidth: "500px",
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(245,250,245,0.92) 100%)",
            backdropFilter: t.blur.heavy,
            WebkitBackdropFilter: t.blur.heavy,
            boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
            borderRadius: t.radius.lg,
            alignSelf: "center",
            color: t.text.primary,
            "&::before": { display: "none" },
          }
        : {}),
    },
    rightSectionOverlay: {
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
      background: "rgba(255,255,255,0.18)",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      zIndex: 3,
    },
    rightSectionOverlayCard: {
      width: "100%",
      maxWidth: 360,
      padding: "28px 24px",
      borderRadius: t.radius.lg,
      background: "linear-gradient(180deg, rgba(255,255,255,0.94) 0%, rgba(248,251,248,0.9) 100%)",
      border: "1px solid rgba(255,255,255,0.5)",
      boxShadow: "0 18px 42px rgba(0,0,0,0.14)",
      textAlign: "center",
      color: "#1d3b1a",
    },
  };
};
